export const RESPONSIVE_LARGE_WIDTH = 480;
export const RESPONSIVE_SMALL_HEIGHT = 700;
export const PREVIEWS_DESKTOP_NAV_MIN_WIDTH = 640;

export const SPEAKER_ROW_PIC_SIZE = '46px';
